// Footer.js

import React from 'react';
import './css/Footer.css';


const Footer = () => {
  return (
    <div className='footer'>

      <p>&copy; 2024 Your Alumni Network</p>
    </div>
  );
};

export default Footer;
